import watchUtils = require("esri/core/watchUtils");
import FeatureLayer = require("esri/layers/FeatureLayer");
import GroupLayer from "esri/layers/GroupLayer";
import MapImageLayer = require("esri/layers/MapImageLayer");
import BuildPopups from "./buildPopups";
import * as layerSource from "./layerSource";

// CRS

export const roadConditionQueryLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.RoadConditionQueryLayer,
  visible: false,
  opacity: 0.0,
  listMode: "hide",
  legendEnabled: false,
  labelsVisible: false,
  title: "RoadConditionQueryLayer",
  outFields: ["*"]
});

export const roadConditionHistoricalLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.CRSHistoricalLayer,
  visible: false,
  opacity: 0.0,
  listMode: "hide",
  legendEnabled: false,
  labelsVisible: false,
  title: "RoadConditionHistoryLayer",
  outFields: ["*"]
});

export const crsFields = ["OBJECTID", "INVENTORY","BEG_STA","CRS_LOW", "CRS_OPP", "CRS_WITH", "CRS_YR", "MARKED_RT"];

export const crsMarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "CRS Marked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.CRSOpposingMarkedLayer,
      title: "CRS Opposing Marked",
      legendEnabled: false
    },
    {
      id: layerSource.CRSWithMarkedLayer,
      title: "CRS With Marked",
      legendEnabled: false
    },
    {
      id: layerSource.CRSMarkedLayer,
      title: "CRS Marked",
      legendEnabled: true
    },
    {
      id: layerSource.CRSTicsMarkedLayer,
      title: "CRS Tics Marked",
      legendEnabled: false
    }
  ]
});

export const crsUnmarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "CRS Unmarked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.CRSWithUnmarkedLayer,
      title: "CRS With Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.CRSOpposingUnmarkedLayer,
      title: "CRS Opposing Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.CRSUnmarkedLayer,
      title: "CRS Unmarked",
      legendEnabled: true
    },
    {
      id: layerSource.CRSTicsUnmarkedLayer,
      title: "CRS Tics Unmarked",
      legendEnabled: false
    }
  ]
});

// IRI

export const iriFields = ["OBJECTID", "INVENTORY","BEG_STA","IRI_LOW", "IRI_OPP", "IRI_WITH", "labelr"];

export const iriMarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "IRI Marked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.IRIOpposingMarkedLayer,
      title: "IRI Opposing Marked",
      legendEnabled: false
    },
    {
      id: layerSource.IRIWithMarkedLayer,
      title: "IRI With Marked",
      legendEnabled: false
    },
    {
      id: layerSource.IRIMarkedLayer,
      title: "IRI Marked",
      legendEnabled: true
    }
  ]
});

export const iriUnmarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "IRI Unmarked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.IRIWithUnmarkedLayer,
      title: "IRI With Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.IRIOpposingUnmarkedLayer,
      title: "IRI Opposing Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.IRIUnmarkedLayer,
      title: "IRI Unmarked",
      legendEnabled: true
    }
  ]
});

// RUT

export const rutFields = ["OBJECTID", "INVENTORY","BEG_STA","RUT_LOW", "RUT_OPP", "RUT_WITH"];

export const rutMarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "Rutting Marked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.RUTOpposingMarkedLayer,
      title: "Rutting Opposing Marked",
      legendEnabled: false
    },
    {
      id: layerSource.RUTWithMarkedLayer,
      title: "Rutting With Marked",
      legendEnabled: false
    },
    {
      id: layerSource.RUTMarkedLayer,
      title: "Rutting Marked",
      legendEnabled: true
    }
  ]
});

export const rutUnmarked = new MapImageLayer({
  url: layerSource.serverUrl,
  title: "Rutting Unmarked",
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.RUTWithUnmarkedLayer,
      title: "Rutting With Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.RUTOpposingUnmarkedLayer,
      title: "Rutting Opposing Unmarked",
      legendEnabled: false
    },
    {
      id: layerSource.RUTUnmarkedLayer,
      title: "Rutting Unmarked",
      legendEnabled: true
    }
  ]
});

// Condition

export const nhsStateandLocalJurisdictionLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.NHSStateandLocalJurisdictionLayer
    }
  ]
});

export const nonNHSStateJurisdictionLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 500000,
  sublayers: [
    {
      id: layerSource.NonNHSStateJurisdictionLayer
    }
  ]
});

export const pavementGroupLayer = new GroupLayer({
  title: "Pavement Condition",
  id: "01 - Pavement",
  visible: true,
  visibilityMode: "independent",
  layers: [nonNHSStateJurisdictionLayer, nhsStateandLocalJurisdictionLayer, roadConditionQueryLayer, rutUnmarked, rutMarked, iriUnmarked, iriMarked, crsUnmarked, crsMarked]
});

pavementGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    if (layer instanceof MapImageLayer)
    {
      if (layer === nonNHSStateJurisdictionLayer || layer ===  nhsStateandLocalJurisdictionLayer) 
      {
        layer.loadAll().then(() => {
          if (layer.sublayers.length === 1) {
            layer.title = layer.sublayers.getItemAt(0).sourceJSON.name;
            layer.sublayers.getItemAt(0).title = layer.sublayers.getItemAt(0).sourceJSON.name;
          }
            BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
        });
      }
    } else {
        BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
    }
  });
});
